<template>
  <div
    id="statistics">
    <div
      class="flex-centered">
      <p
        data-aos="fade-up"
        class="section-title ">
        Nosotros
      </p>
    </div>
    <v-layout 
      row 
      wrap>
      <!-- Start stat values -->
      <v-flex
        class="statistic-flex"
        xs12
        sm12
        md4>
        <p
          data-aos="fade-right"
          class="statistic-value">
          40 +
        </p>
        <p
          data-aos="fade-right"
          class="statistic-label">
          Años de experiencia
        </p>
      </v-flex>
      <v-flex
        class="statistic-flex statistic-flex-middle"
        xs12
        sm12
        md4>
        <p
          data-aos="fade-up"
          class="statistic-value">
          +10000
        </p>
        <p
          data-aos="fade-up"
          class="statistic-label">
          Cirugías
        </p>
      </v-flex>
      <v-flex
        class="statistic-flex"
        xs12
        sm12
        md4>
        <p
          data-aos="fade-left"
          class="statistic-value">
          4k + 
        </p>
        <p
          data-aos="fade-left"
          class="statistic-label">
          Pacientes
        </p>
      </v-flex>
      <!-- End stat values -->
    </v-layout>
  </div>  
</template>
<script>
export default {
}
</script>
<style 
  scoped>
  @media screen and ( max-width: 959px ) {
    .statistic-label {
      font-size: 20px !important
    }

    .statistic-flex {
      height: 200px !important;
      display: inline-grid;
    }

    .statistic-value {
      margin-bottom: -0px !important;
    }

    .statistic-flex-middle {
      border-left-color: transparent !important;
      border-right-color: transparent !important;


      border-top-style: solid;
      border-bottom-style: solid;

      border-top-color: #c6c6c64d;
      border-bottom-color: #c6c6c64d;

      border-top-width: 1px;
      border-bottom-width: 1px;
    }
  } 

  #statistics {
    padding-top: 100px;
    background-color: white;
    position: relative;
    z-index: 2;
    height: auto; 
  }

  .statistic-flex-middle {
    border-left-style: solid;
    border-right-style: solid;

    border-left-color: #C6C6C6;
    border-right-color: #C6C6C6;

    border-left-width: 1px;
    border-right-width: 1px;
  }

  .statistic-flex {
    height: 350px;
    display: inline-grid;
  }

  .statistic-value {
    text-align: center;
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    font-size: 100px;
    color:  #2F80ED;
    align-self: center;
    margin-bottom: -55px;
  }

  .statistic-label {
    text-align: center;
    font-family: 'Raleway', sans-serif;
    font-weight: 600;
    font-size: 20px;
    color:  #282828;
    margin-top: 10px
  }
</style>